import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { ChangeActiveList, ListReleases } from '../action-creators';
import { CHANGE_ACTIVE_LIST } from '../actions';
import { NoOp } from '../../ui/action-creators';


export const getReleasesListEpic = (action$: Observable<ChangeActiveList>) =>
  action$.pipe(
    ofType<ChangeActiveList>(CHANGE_ACTIVE_LIST),
    map((action) => {
      if (action.isSummary) {
        return new NoOp();
      }

      return new ListReleases(action.section);
    })
  );